module.exports = __webpack_public_path__ + "static/media/level-icon.52f6225a.svg";